import {IMapper} from "../i-mapper";
import {IApplicationSettingsToggleField} from "@zaeper/angular-application-store-lib";
import {InputBoolean} from "@zaeper/angular-dashboard-view-lib";
import {FormControl, FormGroup} from "@angular/forms";

export class ApplicationSettingsToggleFieldMapper implements Partial<IMapper<IApplicationSettingsToggleField, InputBoolean>> {
  constructor(private readonly _formGroup: FormGroup) {
  }

  from(applicationSettingsToggleField: IApplicationSettingsToggleField): InputBoolean {
    const formControl: FormControl<boolean> = new FormControl(applicationSettingsToggleField.defaultValue ?? false, {nonNullable: true});

    this._formGroup.setControl(applicationSettingsToggleField.id, formControl);

    const enabledLabel: string | undefined = applicationSettingsToggleField.enabledText?.de;
    const disabledLabel: string | undefined = applicationSettingsToggleField.disabledText?.de;
    const title: string = enabledLabel && disabledLabel
      ? `${applicationSettingsToggleField.label.de} (${enabledLabel} / ${disabledLabel})`
      : applicationSettingsToggleField.label.de;

    return new InputBoolean({
      formControlEntry: {
        formControl: formControl, key: applicationSettingsToggleField.id
      },
      title: title,
      inputId: applicationSettingsToggleField.id,
      required: applicationSettingsToggleField.required ?? false
      // TODO Phase 3: expose enabled/disabled labels as dedicated fields on InputBoolean; honor `description` + `compact`
    });
  }
}
